<div class="instalar-app" *ngIf="visible" role="dialog" aria-label="Instalar la aplicación">
  <img src="assets/icons/icon-192.png" alt="" class="instalar-icono">
  <div class="instalar-texto">
    <strong>Instala Iturri RRHH</strong>
    <span *ngIf="modo === 'boton'">Tenla a un toque en tu pantalla de inicio, como una aplicación.</span>
    <span *ngIf="modo === 'ios'">
      Toca <span class="ios-compartir" aria-label="Compartir">
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M12 2l4 4h-3v9h-2V6H8l4-4zM5 10h4v2H6v8h12v-8h-3v-2h4a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V11a1 1 0 011-1z"/></svg>
      </span> <b>Compartir</b> y luego <b>Agregar a pantalla de inicio</b>.
    </span>
  </div>
  <button type="button" class="instalar-boton" *ngIf="modo === 'boton'" (click)="instalar()">Instalar</button>
  <button type="button" class="instalar-cerrar" (click)="cerrar()" aria-label="Cerrar">&times;</button>
</div>
